import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import { useStaticQuery, graphql } from 'gatsby';
import { MediaCardProps } from 'molecules/MediaCard/MediaCard';
import MediaCardCarouselWithTextBlock from 'molecules/MediaCardCarouselWithTextBlock/MediaCardCarouselWithTextBlock';
import { IStaticContentfulImages } from 'src/types/contentful';

const TonyRobbinsArenaFeed = (): JSX.Element => {
  const assets = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      imageCard0: contentfulAsset(contentful_id: { eq: "6qi7gUV2ndv4nu36vyKl7F" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard1: contentfulAsset(contentful_id: { eq: "76yQFce8CX8C4ChO7eUFC2" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard2: contentfulAsset(contentful_id: { eq: "1HN5BtpQOvXnlyKzoZKHab" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard3: contentfulAsset(contentful_id: { eq: "6SZUakFjnAHlr5cXrO78Cv" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard4: contentfulAsset(contentful_id: { eq: "1zaMNbe01VwW8AEvaAH05C" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
    }
  `);

  const imageMaxWidth = 360;

  const cards: MediaCardProps[] = [
    {
      image: {
        image: assets.imageCard0.gatsbyImageData,
        alt: 'Same Strategy Different Scale Image 0',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard1.gatsbyImageData,
        alt: 'Same Strategy Different Scale Image 1',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard2.gatsbyImageData,
        alt: 'Same Strategy Different Scale Image 2',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard3.gatsbyImageData,
        alt: 'Same Strategy Different Scale Image 3',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard4.gatsbyImageData,
        alt: 'Same Strategy Different Scale Image 4',
      },
      imageMaxWidth,
    },
  ];

  return (
    <Grid>
      <MediaCardCarouselWithTextBlock
        heading={{
          type: 'heading',
          text: 'Tony Robbins Arena',
          size: 'lg',
          letterSpacing: -1,
        }}
        supportingText={{
          type: 'paragraph',
          text: "Tony Robbins Arena has scaled to 30,000+ members on Mighty. Virtual event attendance grew from 150 to over 1,000 live viewers after moving to Mighty's branded apps on Mighty Pro.",
          size: 'xl',
          color: 'text-tertiary',
        }}
        cards={cards}
      />
    </Grid>
  );
};

export default TonyRobbinsArenaFeed;
